import { Box, Stack } from '@mui/material'
import { memo } from 'react'

import PopoverHelpText from 'src/components/shared/popoverHelpText/PopoverHelpText'

const SummaryWidget = ({ title, value, helpText, action }) => {
  return (
    <Box
      sx={{
        gap: 2,
        bgcolor: 'background.neutral',
        borderRadius: 1.5,
        p: 2,
        display: 'flex',
        flexDirection: 'column'
      }}
    >
      <Box sx={{ typography: 'subtitle2' }}>
        {title}
        {helpText && <PopoverHelpText label={helpText} />}
      </Box>
      <Stack
        direction='row'
        spacing={2}
        justifyContent='space-between'
        alignItems='center'
      >
        <Box sx={{ typography: 'h3' }}>{value}</Box>
        {action}
      </Stack>
    </Box>
  )
}

export default memo(SummaryWidget)
